module.exports = __webpack_public_path__ + "img/process-small1.40118c59.png";